// extracted by css-extract-rspack-plugin
export default {"cls1":"StickyWorkCardHeader-cls1_dFo","cls2":"StickyWorkCardHeader-cls2_cKP StickyWorkCardHeader-cls1_dFo"};